import * as z from 'zod'

// Schema for profile form validation
export const profileSchema = z.object({
  username: z
    .string()
    .min(3, { message: 'Username must be at least 3 characters' })
    .max(20, { message: 'Username must be at most 20 characters' })
    .regex(/^[a-zA-Z0-9_-]+$/, {
      message: 'Username can only contain letters, numbers, underscores, and hyphens',
    }),
  avatar_url: z.string().url().optional().or(z.literal('')),
  bio: z.string().max(200, { message: 'Bio must be at most 200 characters' }).optional(),
  location: z.string().max(50, { message: 'Location must be at most 50 characters' }).optional(),
})

export type ProfileFormValues = z.infer<typeof profileSchema>
